import { CircularProgress } from '@mui/material';
import { useMemo } from 'react';
import { SelectElement } from 'react-hook-form-mui';
import { useTranslation } from 'react-i18next';

import { useSettingValues } from '@/features/settings';
import { SettingIdValue } from '@/types/api';

export const ItemTypeSelect = () => {
  const { t } = useTranslation();
  const { getSettingValue, isLoading } = useSettingValues();
  const itemTypes = getSettingValue<SettingIdValue<string>[]>('itemTypes', []);

  const itemTypeOptions = useMemo(() => {
    return [
      { id: '', label: t('itemTemplates.detail.selectPlaceholder') },
      ...itemTypes.map(({ id, value }) => ({ id, label: value })),
    ];
  }, [itemTypes, t]);

  const label = isLoading ? <CircularProgress size={20} /> : t('itemTemplates.detail.itemType');

  return <SelectElement name="itemTypeId" label={label} fullWidth options={itemTypeOptions} />;
};
